<template>
  <div class="top-left-chart-container">
    <div class="top-left-chart-inner"></div>
  </div>
</template>

<script>
export default {
  name: "UsersTopLeftChartsContainer"
};
</script>

<style scoped>
.top-left-chart-container {
  float: left;
  width: calc(45%);
  background: white;
}
.top-left-chart-inner {
  overflow: hidden;
  min-height: 100%;
  position: relative;
  font-family: Montserrat;
  padding-top: 12px;
  padding-right: 12px;
}
</style>
